var exports = {
  "kL": "FormSwitch.module__container___RGtJNG",
  "oE": "FormSwitch.module__compact___RGtJNG",
  "_A": "FormSwitch.module__labelContainer___RGtJNG",
  "Pf": "FormSwitch.module__label___RGtJNG",
  "r9": "FormSwitch.module__disabled___RGtJNG",
  "vk": "FormSwitch.module__clickable___RGtJNG",
  "h_": "FormSwitch.module__description___RGtJNG",
  "HV": "FormSwitch.module__switchRoot___RGtJNG",
  "L8": "FormSwitch.module__switchThumb___RGtJNG",
  "nL": "FormSwitch.module__iconChecked___RGtJNG",
  "ao": "FormSwitch.module__iconUnchecked___RGtJNG",
};

module.exports = exports;
